import jsPDF from 'jspdf';
import moment from 'moment';
import { drawCabeceraLogo, drawFooterEmpresa } from './empresa_pdf';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportPDFBriefCambios (brief, empresa) {
      let pdfName = `brief_cambios_${brief.id}`; 
      /* Parametros: portrait, milimetros, A4 */
      var doc = new jsPDF('p', 'mm', 'a4');
      /* Cantidad de paginas */
      let pages = 1;

      doc.setProperties({
        title: 'Brief',
        subject: 'Brief',		
        author: 'Cervertti - Marketing & Eventos',
        creator: 'Cervetti'
      });

      // let fontName = 'CenturyGothic';
      // let fontBoldName = 'CenturyGothicBold';
      // let fontItalicName = 'CenturyGothicItalic';
      // let fontBoldItalicName = 'CenturyGothicBoldItalic';

      let fontName = 'Montserrat-Regular';
      let fontBoldName = 'Montserrat-Bold';
      let fontItalicName = 'Montserrat-Italic';
      let fontBoldItalicName = 'Montserrat-BoldItalic';

      /* Inicial renglones */
      let positionRenglonesY = 70;
      /* Limite para el salto de página */
      let positionMaxY = 275;
      
      /* Interlineado */
      let interlineado = 4;
      let interlineadoCambios = 6;

      /* Formato para alinear numeros a la derecha */
      let alignRight = {
        'align': 'right'
      }

      drawCabecera(doc, empresa, brief, 
        fontName, fontBoldName, fontItalicName, fontBoldItalicName);
  
      /* Renglones */
      let positionY = positionRenglonesY;
      
      // doc.setFontSize(8);
      // doc.setFont(fontBoldName, 'bold');
      // doc.text( 'Validación Técnica' , 10, positionY);
      // positionY += interlineado;
      // doc.setFont(fontName, 'normal');
      // if (moment(brief.fechaValidacionTecnica).format('YYYY-MM-DD') != '1900-01-01') {
      //   doc.text( `Fecha: ${moment(brief.fechaValidacionTecnica).format('DD/MM/YYYY HH:mm')}` , 10, positionY);
      // } else {
      //   doc.text( `Fecha:` , 10, positionY);
      // }
      // positionY += interlineado;
      // doc.text( `Validador/a: ${brief.usuarioValidacionTecnica}` , 10, positionY);

      // positionY += interlineadoCambios;
      // doc.setFont(fontBoldName, 'bold');
      // doc.text( 'Validación Comercial' , 10, positionY);
      // positionY += interlineado;
      // doc.setFont(fontName, 'normal');
      // if (moment(brief.fechaValidacionInformacion).format('YYYY-MM-DD') != '1900-01-01') {
      //   doc.text( `Fecha: ${moment(brief.fechaValidacionInformacion).format('DD/MM/YYYY HH:mm')}` , 10, positionY);
      // } else {
      //   doc.text( `Fecha:` , 10, positionY);
      // }
      // positionY += interlineado;
      // doc.text( `Validador/a: ${brief.usuarioValidacionInformacion}` , 10, positionY);

      // positionY += interlineado;
      // doc.setDrawColor(151, 148, 149); 
      // doc.setLineWidth(0.3);
      // doc.line(10, positionY, 200, positionY);

      // positionY += interlineadoCambios;
      
      doc.setFont(fontBoldName, 'bold');
      doc.text( 'Listado de Cambios' , 10, positionY);
      positionY += 2;

      let inicial = true;

      for(let key in brief.cambios) {
        const briefCambio = brief.cambios[key];

        /* Verificamos si entra el titulo de la OT y al menos dos renglones */
        if (positionY + interlineadoCambios + 5 > positionMaxY) {
          /* Agregamos el footer */
          drawFooterEmpresa(doc, empresa, fontName);

          /* Agregamos una nueva pagina */
          doc.addPage();
          pages++;
          drawCabecera(doc, empresa, brief, 
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
          
          positionY = positionRenglonesY;
        } else {
          if (inicial) {
            positionY += 4;
            inicial = false;
          } else {
            positionY += interlineadoCambios;
          }
        }

        doc.setFont(fontBoldName, 'bold');
        doc.text( `Cambio ${brief.cambios.length - key}` , 10, positionY);
        positionY += interlineado;
        doc.setFont(fontName, 'normal');
        doc.text( `Fecha: ${moment(briefCambio.fechaUltimaEdicion).format('DD/MM/YYYY HH:mm')}` , 10, positionY);
        positionY += interlineado;
        doc.text( `Usuario: ${briefCambio.usuario}` , 10, positionY);
        positionY += 2;

        let lineasDescripcion = briefCambio.cambios.split(/\r?\n/g);

        for (let linea = 0; linea < lineasDescripcion.length; linea++) {

          if (positionY + interlineado >= positionMaxY) {
            /* Agregamos el footer */
            drawFooterEmpresa(doc, empresa, fontName);

            /* Agregamos una nueva pagina */
            doc.addPage();
            pages++;
            drawCabecera(doc, empresa, brief, 
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
            
            positionY = positionRenglonesY;

            doc.setFontSize(6);
            doc.setFont(fontName, 'normal');
            // doc.setFontType('normal');
            
            doc.text('Continuación ...', 15, positionY);

            doc.setFontSize(8);

            positionY += interlineado + 2;

          } else {
            positionY += interlineado;
          }

          let lineaDescripcion = lineasDescripcion[linea];

          if (lineaDescripcion.length > 130) {
            while (lineaDescripcion.length > 130) {
              let lastSpace = lineaDescripcion.substring(0, 130).search(/ [^ ]*$/);
              doc.text(lineaDescripcion.substring(0, lastSpace).trim(), 10, positionY);
              positionY += interlineado;

              lineaDescripcion = lineaDescripcion.substring(lastSpace + 1).trim();

            }
            if (lineaDescripcion.trim() != '') {
              doc.text(lineaDescripcion.trim(), 10, positionY);
            }
            
            /* Dividimos la linea en dos */
            // positionY += interlineado;
            // doc.text(lineaDescripcion.substring(lastSpace + 1).trim(), 10, positionY);

          } else {
            doc.text(lineaDescripcion, 10, positionY);
          }
        }

        if (positionY + 5 >= positionMaxY) {
          /* Agregamos el footer */
          drawFooterEmpresa(doc, empresa, fontName);

          /* Agregamos una nueva pagina */
          doc.addPage();
          pages++;
          drawCabecera(doc, empresa, brief, 
            fontName, fontBoldName, fontItalicName, fontBoldItalicName);
          
          positionY = positionRenglonesY;

        } else {
          positionY += interlineado + 2;
        }
      }
  
      drawFooterEmpresa(doc, empresa, fontName);

      /* Numeramos las páginas */
      for (let index = pages - 1; index >= 0; index--) {
        doc.setPage(index + 1);
        doc.setFont(fontName, 'normal');
        doc.setFontSize(6);
        doc.setTextColor(0, 0, 0);
        doc.text(`Página ${index + 1} de ${pages}`, 10, 286);
      }

      window.open(doc.output("bloburl", { filename: pdfName + '.pdf' } ));

      return;
    },
  }
}

function drawCabecera(doc, empresa, brief, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {

  drawCabeceraLogo(doc, empresa, fontName);

  /* Titulo */
  doc.setFont(fontName, 'normal');
  doc.setFontSize(24);
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);
  doc.text('Brief', 90, 20);

  /* Datos del cliente */
  doc.setFontSize(8);
  doc.setTextColor(60, 60, 60);
  
  let positionY = 48;
  doc.text(`Nro. Brief: ${brief.id}`, 10, positionY);
  positionY += 4;
  doc.text(`Nro. Presupuesto: ${brief.presupuestoNumero}`, 10, positionY);
  positionY += 4;
  doc.text(`Cliente: ${brief.cliente.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Acción: ${brief.accion.trim()}`, 10, positionY);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  doc.line(10, 62, 200, 62);
}

